@for (user of persons$ | async; track user) {
  <ion-chip>
    <div></div>
    {{ user }}
  </ion-chip>
}